// Modelo Compañia para administrador.
export default class Catalog {
    id=""
    code=""
    name=""
    enabled=true
    catalogueItemId=""
    type=""
}



// WEBPACK FOOTER //
// ./src/model/Catalog.js